<template>
  <v-container fluid class="pa-0 fill-height">
    <router-view />
  </v-container>
</template>

<script>
// import RegisterStoreModule from '@/mixins/RegisterStoreModule'
// import chatStore from './store.js'

export default {
  name: 'chat',
  // mixins: [RegisterStoreModule],
  // created() {
  //   this.registerStoreModule('chat', chatStore)
  // },
}
</script>
